module.exports = {
  dirToGalleryPath: (dirPath) => {
    const sanitized = dirPath
      .replace(/['()![\]#?%&^@",<>\\*+=~`]/g, "-")
      .replace(/\s/g, "-")
      .toLowerCase()
    return `/gallery/${sanitized}`
  }
}